module.exports = __webpack_public_path__ + "img/start.5580943d.png";